import { render, staticRenderFns } from "./CrossTab.vue?vue&type=template&id=34728254&scoped=true"
import script from "./CrossTab.vue?vue&type=script&lang=ts"
export * from "./CrossTab.vue?vue&type=script&lang=ts"
import style0 from "./CrossTab.vue?vue&type=style&index=0&id=34728254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34728254",
  null
  
)

export default component.exports